import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
  FormControl,
  FormLabel,
  Select,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Tooltip,
  Skeleton,
  Box,
  SkeletonCircle,
  SkeletonText,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import {
  candidateDepartmentAsyn,
  candidateExpAsync,
  deleteExpAsyn,
  selectFetchedExperience,
} from "../../CandProfCreation/CandidateProfileSlice/Experience/ExperienceSlice";
import { fetchToken } from "../..//common/FetchCookie";
import Experience from "../../CandProfCreation/components/Experience";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { selectToken } from "../../common/FetchTokenSlice";
import {
  selectExperienceResponse,
  updateCandidateExperienceAsync,
} from "../../CandProfCreation/CandidateProfileSlice/Experience/ExperienceSlice2";
import { candidateExp } from "../../CandProfCreation/CandidateProfileSlice/Experience/ExperienceAPI";
import { useForm } from "react-hook-form";
import {
  fetchJobDepartmentsAsync,
  selectJobDepartments,
} from "../../AdminPanel/JobPostingSlice/JobDepartment/JobDepartmentSlice";
import { fetchJobEducationAsync } from "../../AdminPanel/JobPostingSlice/JobEducation/JobEducationSlice";
import { fetchJobEducationCourseAsync } from "../../AdminPanel/JobPostingSlice/JobEducationCourse/JobEducationCourceSlice";
import {
  fetchPublicJobTitlesAsync,
  selectJobTitles,
} from "../../AdminPanel/JobPostingSlice/JobTitles/JobTitlesSlice";
import Projects from "../../CandProfCreation/CandidateProfileSlice/Project/Projects";
import ExperienceShowTesting from "./ExperienceShowTesting";

export default function ExperienceShow() {
  // const { isOpen, onOpen, onClose } = useDisclosure();
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalOpenWithValue, setModalOpenWithValue] = useState(null);
  const dispatch = useDispatch();
  const experience = useSelector(selectFetchedExperience);
  const [rerendring, setRerendering] = useState(false);
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const department = useSelector(selectJobDepartments);
  const jobTitle = useSelector(selectJobTitles);
  const [useToken, setUserToken] = useState("");
  const token = useSelector(selectToken);

  useEffect(() => {
    // if(token){
    //   dispatch(candidateExpAsync({token: token}));
    // }
    dispatch(fetchPublicJobTitlesAsync());
    dispatch(fetchJobDepartmentsAsync());
    dispatch(fetchJobEducationAsync());
    dispatch(fetchJobEducationCourseAsync());
  }, [token, dispatch]);

  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };
  const saveModal = () => {
    console.log("saved the changes");
    setModalOpen(false);
  };

  const openModalWithValue = (user) => {
    setModalOpenWithValue(user);
  };
  const monthList = [
    { value: 1, month: "January" },
    { value: 2, month: "February" },
    { value: 3, month: "March" },
    { value: 4, month: "April" },
    { value: 5, month: "May" },
    { value: 6, month: "June" },
    { value: 7, month: "July" },
    { value: 8, month: "August" },
    { value: 9, month: "September" },
    { value: 10, month: "October" },
    { value: 11, month: "November" },
    { value: 12, month: "December" },
  ];

  useEffect(() => {
    const fetchExperience = async () => {
      setIsLoading(true);
      try {
        const token = await fetchToken();
        setUserToken(token);
        console.log("token:- ", token);
        await dispatch(candidateExpAsync(token));
        console.log("successfully fetched");
      } catch (error) {
        console.log("error: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchExperience();
  }, [dispatch, rerendring, isModalOpen]);

  useEffect(() => {
    const prefilledHasOffer = false; // Replace with actual prefilled value from data
    setHasOffer(prefilledHasOffer);
  }, []);

  // const handleDelete = async (id) => {
  //   await dispatch(deleteExpAsyn({ token: useToken, id: id }));
  //   setRerendering(true);
  //   console.log("successfully deleted");
  // };

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: errors,
  } = useForm();

  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const {
    isOpen: isOpen3,
    onOpen: onOpen3,
    onClose: onClose3,
  } = useDisclosure();

  const handleCheckboxChange = (event) => {
    setHasOffer(event.target.checked); // Update the state based on the checkbox value
  };

  const [hasOffer, setHasOffer] = useState(false);

  const handleUpdate = async (CandidateExperienceData) => {
    if (selectedExperience) {
      try {
        // console.log("Selected Experience ID:", selectedExperience.uuid);

        // const token = await fetchToken();
        // setUserToken(token);

        // Prepare the data to be sent for updating
        const updatedExperienceData = {
          ...CandidateExperienceData, // Include the candidate experience data
          has_any_offer: hasOffer, // Include the offer condition
          last_working_date: hasOffer
            ? CandidateExperienceData.last_working_date
            : "", // If hasOffer, send the last working date
          offered_job_title_uuid: hasOffer
            ? CandidateExperienceData.offered_job_title_uuid
            : null, // Include job title if hasOffer
          offered_salary_currency: hasOffer
            ? CandidateExperienceData.offered_salary_currency
            : "", // Include salary currency if hasOffer
          offered_salary_amount: hasOffer
            ? CandidateExperienceData.offered_salary_amount
            : null, // Include salary amount if hasOffer
        };

        // Dispatch the action to update candidate experience
        await dispatch(
          updateCandidateExperienceAsync({
            uuid: selectedExperience.uuid,
            CandidateExperienceData: updatedExperienceData,
          })
        );

        // Fetch updated candidate experience after the update
        await dispatch(candidateExpAsync(token));

        // Reset the selected experience and close the modal
        setSelectedExperience(null);
        reset();
        onClose2();
      } catch (error) {
        console.error("Failed to update experience:", error);
        if (error.response?.status === 401) {
          console.error("Authentication error - please check token validity");
        }
      }
    }
  };

  const openUpdateModal = (experience) => {
    if (!experience) {
      console.warn("No experience data provided");
      return;
    }
    console.log("Selected Experience", experience);

    // Set the selected experience data
    setSelectedExperience(experience);

    // Set each form field based on the provided experience data
    Object.keys(experience).forEach((key) => {
      setValue(key, experience[key]);
    });

    // Check if the experience has an offer and update the state
    if (experience.has_any_offer) {
      setHasOffer(true);

      // Prefill offer-related fields
      setValue("last_working_date", experience.last_working_date || "");
      setValue(
        "offered_job_title_uuid",
        experience.offered_job_title_uuid || ""
      );
      setValue(
        "offered_salary_currency",
        experience.offered_salary_currency || ""
      );
      setValue("offered_salary_amount", experience.offered_salary_amount || "");
    } else {
      setHasOffer(false);

      // Clear offer-related fields
      setValue("last_working_date", "");
      setValue("offered_job_title_uuid", "");
      setValue("offered_salary_currency", "");
      setValue("offered_salary_amount", "");
    }

    // Open the modal after setting values
    onOpen2();
  };

  const [deletingExperience, setDeletingExperience] = useState(null);

  // Function to open delete modal and set the item to be deleted
  const openDeleteModal = (items) => {
    setDeletingExperience(items);
    onOpen3(); // Open the modal after setting the experience to delete
  };

  // Function to handle deletion
  const handleDelete = async (uuid) => {
    if (token) {
      try {
        // Delete the selected experience
        await dispatch(deleteExpAsyn({ token: token, uuid: uuid }));

        // Refresh the experience list after deletion
        await dispatch(candidateExpAsync(token));
        onClose3();

        // Close the modal after deletion
      } catch (error) {
        console.error("Failed to delete experience:", error);
      }
    }
  };

  return (
    <div className="">
      <div
        className="py-3 min-h-screen sm:px-12  bg-mainBg flex flex-col"
        style={{ fontFamily: "Inter, sans-serif" }}
      >
        <Tabs>
          <TabList>
            <Tab>Experience</Tab>
            <Tab>Projects</Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <ExperienceShowTesting />
            </TabPanel>
            <TabPanel>
              <Projects />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </div>
  );
}
